module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.3ded831.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-solid-900.woff
// module id = 342
// module chunks = 1